import { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

export function FAQSection({ faqs, color = '#03228D' }) {
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (!faqs || faqs.length === 0) return;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map(faq => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: { '@type': 'Answer', text: faq.a },
      })),
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.head.removeChild(script); };
  }, [faqs]);

  if (!faqs || faqs.length === 0) return null;

  return (
    <section data-testid="faq-section" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="font-cabin text-sm uppercase tracking-[0.2em] mb-4 font-semibold" style={{ color }}>Questions frequentes</p>
          <h2 className="font-cabin text-3xl md:text-4xl font-semibold text-[#141C39] tracking-tight">FAQ</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} data-testid={`faq-item-${i}`} className="border border-[#e5e7eb] rounded-[5px] overflow-hidden">
              <button onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-[#F5F7FA] transition-colors">
                <span className="font-cabin text-sm font-semibold text-[#141C39] pr-4">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 shrink-0 text-[#141C39]/30 transition-transform ${open === i ? 'rotate-180' : ''}`} />
              </button>
              {open === i && (
                <div className="px-5 pb-5 pt-0">
                  <p className="text-sm text-[#141C39]/60 font-dm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
